export const zoomToFeature = (
  mapObject: any,
  extent: any,
  extentRadius: number = 1,
  expand?: boolean,
  unit: string = 'kilometers'
) => {
  const {
    loadedView,
    loadedMapModules
  }: { loadedView: __esri.MapView; loadedMapModules: any } = mapObject;

  if (!loadedMapModules || !loadedView || loadedView.destroyed || !extent) {
    return;
  }

  const { GeometryEngine } = loadedMapModules;

  const performZoom = () => {
    if (!loadedView || loadedView.destroyed) {
      return;
    }

    let bufferExtentVal = extent;

    try {
      if (extentRadius > 0) {
        const bufferExtent = GeometryEngine.geodesicBuffer(
          extent,
          extentRadius,
          unit
        );
        bufferExtentVal = bufferExtent?.extent || extent;
      }
    } catch {
      bufferExtentVal = extent;
    }

    if (expand && bufferExtentVal?.clone) {
      bufferExtentVal = bufferExtentVal.clone().expand(1.3);
    }

    return loadedView.goTo(bufferExtentVal).catch((error: any) => {
      if (error.name !== 'AbortError') {
        console.warn('Error zooming to feature:', error);
      }
    });
  };

  loadedView.when(() => performZoom()).catch(() => performZoom());
};

export const calculateArea = (
  mapObject: any,
  geometry: any,
  unit: string = 'square-kilometers'
) => {
  const { loadedMapModules } = mapObject;
  if (loadedMapModules) {
    const { GeometryEngine } = loadedMapModules;
    return GeometryEngine.geodesicArea(geometry, unit);
  }
  return '';
};
